import "markdown-it";
import { timestampToISO } from "../format/timestampToISO.js";
import { getUTCTimeObject } from "./getUTCTimeObject.js";
function compareTime(dateStr1, dateStr2) {
  const date1 = typeof dateStr1 === "number" ? new Date(timestampToISO(dateStr1)) : new Date(dateStr1);
  const date2 = typeof dateStr2 === "number" ? new Date(timestampToISO(dateStr2)) : new Date(dateStr2);
  const time1 = getUTCTimeObject(date1);
  const time2 = getUTCTimeObject(date2);
  if (time1.hours !== time2.hours) {
    return time1.hours - time2.hours;
  }
  if (time1.minutes !== time2.minutes) {
    return time1.minutes - time2.minutes;
  }
  return time1.seconds - time2.seconds;
}
export {
  compareTime
};
